import { action } from "easy-peasy";
import { IProjectInContractProps } from "../interface/organization";
import {
  ACCOUNT_TYPE,
  IUser,
  IUserDetails,
  UserContract,
} from "../interface/user";

export const emptyUser: IUserDetails = {
  authenticated: false,
  uid: "",
  accountType: ACCOUNT_TYPE.normal,
  loading: true,
  email: "",
  orgStatus: "",
  flags: [],
  lang: "pl",
  //ToDo dodac poprawne wartości
  orgRole: "user",
  orgID: "",
  contracts: [],
  configs: [],
};

export const user: IUser = {
  userDetails: { ...emptyUser },

  //actions
  clearUser: action((state) => {
    state.userDetails = { ...emptyUser };
  }),

  setAuthenticated: action((state, payload) => {
    state.userDetails.authenticated = payload;
  }),

  setUserDetails: action((state, payload) => {
    state.userDetails = payload;
  }),

  removeContractFromUser: action((state, payload) => {
    const contracts = state.userDetails.contracts.filter(
      (_contract) => _contract.contractID !== payload
    );

    state.userDetails.contracts = contracts;
  }),

  editContractName: action((state, payload) => {
    const newContracts = [...state.userDetails.contracts];
    const contact = newContracts.find(
      (item) => item.contractID === payload.contractID
    );
    if (contact) {
      contact.contractName = payload.contractName;
    }
    state.userDetails.contracts = newContracts;
  }),

  setOrgStatus: action((state, payload) => {
    state.userDetails.orgStatus = payload;
  }),

  setLang: action((state, payload) => {
    state.userDetails.lang = payload;
  }),

  setConfing: action((state, payload) => {
    const newConfigs = [...state.userDetails.configs];
    const ifExist = newConfigs.find(
      (_config) => _config.configName === payload.configName
    );
    if (ifExist) {
      ifExist.config = payload.config;
    } else {
      newConfigs.push({
        configName: payload.configName,
        config: payload.config,
      });
    }
    state.userDetails.configs = newConfigs;
  }),

  addContractToUser: action((state, payload) => {
    const newContracts = [...state.userDetails.contracts, payload];
    state.userDetails.contracts = newContracts;
  }),

  removeProjectFromUser: action((state, payload) => {
    const newContracts = [...state.userDetails.contracts];
    const removedContractsIDs: string[] = [];
    newContracts.forEach((_contract) => {
      const projects = _contract.projects;
      const hadLimitedProjects = Array.isArray(projects) && projects.length > 0;

      if (hadLimitedProjects) {
        if (typeof projects[0] === "string") {
          _contract.projects = (projects as string[]).filter(
            (_project) => _project !== payload.projectID
          );
        } else {
          const filteredProjects = (projects as IProjectInContractProps[]).filter(
            (_project) => _project.projectID !== payload.projectID
          );
          _contract.projects = filteredProjects;
        }
      }

      if (hadLimitedProjects && _contract.projects?.length === 0) {
        removedContractsIDs.push(_contract.contractID);
      }
    });
    state.userDetails.contracts = newContracts.filter(
      (_contract) => !removedContractsIDs.includes(_contract.contractID)
    );
  }),

  updateContractsInUser: action((state, payload) => {
    const newContracts: UserContract[] = [];
    payload.changes.forEach((_change) => {
      const contractDetails = payload.contracts.find(
        (c) => c.id === _change.id
      );
      if (contractDetails) {
        newContracts.push({
          id: _change.id,
          projects: _change.projects as string[],
          contractID: contractDetails.contractID,
          contractName: contractDetails.contractName,
        });
      }
    });
    state.userDetails.contracts = newContracts;
  }),
};
